import { useEffect, useRef, useState } from 'react';
export function useAuthConfigFetch(fetchAuthConfig) {
  const [configFetchState, setConfigFetchState] = useState({
    status: 'pending'
  });
  const fetchAuthConfigRef = useRef(fetchAuthConfig);
  fetchAuthConfigRef.current = fetchAuthConfig;
  useEffect(() => {
    let cancelled = false;
    fetchAuthConfigRef.current().then(authConfig => {
      if (!cancelled) {
        setConfigFetchState(() => ({
          status: 'succeeded',
          config: authConfig
        }));
      }
    }).catch(err => {
      if (!cancelled) {
        setConfigFetchState(() => ({
          status: 'failed',
          err
        }));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return configFetchState;
}